export function getCrossbrowserEventPath(event: Event): EventTarget[] {
  const path = event['path'] || (event.composedPath && event.composedPath()); // Firefox doesn't have "path" property in event

  return path;
}
